/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Form, Formik } from 'formik';
import { useHistory, useLocation } from 'react-router-dom';
import * as yup from 'yup';
import { camelCase, uniqueId } from 'lodash';

import Layout from 'components/Layout';
import StepNavigation from 'components/StepNavigation'
import Loader from 'components/Loader';
import Row from "components/Grid/Row";
import Col from "components/Grid/Col";
import BrokingSummary from 'components/BrokingSummary';
import { FitinsurAPI, MessageCenter } from 'utils';
import MasksHelper from 'utils/src/masks';
import Colors from 'constants/Colors';
import {
  FormSection,
  Button,
  ButtonContainer,
  LostCancelButton,
  HasPermission,
  FormContainer
} from '@fitinsur/components';
import {
  AuthContext,
  LoaderContext
} from '@fitinsur/contexts'
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import {
  Content,
  BrokerContainer,
  ButtonContent,
  ClausesContainer,
  ClauseContent
} from './styles';
import Mask from 'utils/src/mask';
import { useGenerateQuote } from 'services/QuoteService';
import {
  useGetQuestionnaireAnswer,
  useSaveQuestionnaireAnswer,
} from 'services/QuestionnaireAnswerService';
import { onValidationError } from 'containers/edit/handleQuestionChange';
import { useGetDocuments } from 'services/DocumentsService';
import {
  useRequestSompoGetInternalProcessNumber,
} from 'services/IssueService';
import {
  useCheckConsumption
} from '@fitinsur/services/CreditLimitService';

export default function QuoteLetter({ permissions, ...props }) {
  const { updateIsLoadingStatus } = useContext(LoaderContext);
  const validationSchema = useRef(yup.object().shape({}));
  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const history = useHistory();
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const formikRef = useRef({});
  const location = useLocation();
  const handleBack = () => history.goBack();
  const maskHelper = new MasksHelper();
  const goToNextPage = useRef(false);

  const [operation, setOperation] = useState({});
  const [initialValues, setInitialValues] = useState({});
  const [questionnaire, setQuestionnaire] = useState([]);
  const [sumMaxLimit, setSumMaxLimit] = useState([]);
  const [currentModality, setCurrentModality] = useState(null);
  const [clauseGroups, setClauseGroups] = useState([]);
  const [idProductPlan, setIdProductPlan] = useState(0);

  const SECTIONS = {
    QUOTE_LETTER: { name: 'QUOTE_LETTER', isMultiple: false, isRisk: false }
  };

  const {
    data: useGetDocumentsData,
    loading: useGetDocumentsLoading,
    error: useGetDocumentsError,
    status: useGetDocumentsStatus,
    request: useGetDocumentsRequest
  } = useGetDocuments(props.match.params.idOperation);

  const {
    data: useGetQuestionnairesAnswersData,
    loading: useGetQuestionnairesAnswersLoading,
    error: useGetQuestionnairesAnswersError,
    status: useGetQuestionnairesAnswersStatus,
    request: useGetQuestionnairesAnswersRequest,
  } = useGetQuestionnaireAnswer(props?.match?.params?.idOperation);

  const {
    data: useSaveQuestionnaireAnswerData,
    loading: useSaveQuestionnaireAnswerLoading,
    error: useSaveQuestionnaireAnswerError,
    status: useSaveQuestionnaireAnswerStatus,
    request: useSaveQuestionnaireAnswerRequest,
  } = useSaveQuestionnaireAnswer(props?.match?.params?.idOperation);

  const {
    data: useGenerateQuoteData,
    loading: useGenerateQuoteLoading,
    error: useGenerateQuoteError,
    status: useGenerateQuoteStatus,
    request: useGenerateQuoteRequest
  } = useGenerateQuote(props?.match?.params?.idOperation);

  const {
    loading: useRequestSompoGetInternalProcessNumberLoading,
    request: useRequestSompoGetInternalProcessNumberRequest,
  } = useRequestSompoGetInternalProcessNumber();

  const {
    data: useCheckConsumptionData,
    loading: useCheckConsumptionLoading,
    error: useCheckConsumptionError,
    status: useCheckConsumptionStatus,
    request: useCheckConsumptionRequest,
  } = useCheckConsumption(props?.match?.params?.idOperation);

  const handleQuestionnaire = async (data) => {
    let questionnaire = [];
    questionnaire = [
      ...data.persons,
      ...data.operations,
      ...data.payments,
      ...data.risks
    ];

    questionnaire = questionnaire.sort((a, b) => a.sequenceQuestion - b.sequenceQuestion);

    setQuestionnaire(questionnaire);
  }

  const buildValidation = () => {
    const validationSchema = {};

    const fieldErrorMessage = (question) => {
      mc.error(`O Campo: ${question.dsQuestion} é Obrigatório`);
      return "* Campo Obrigatório"
    };

    const questionnaire = handleSaveQuestionnaireAnswer(formikRef?.current?.values, false, true);
    for (const question of questionnaire) {
      if (!question.key || question.behaviorObject.sectionName === "INSURED") continue;
      validationSchema[question.key] = question.visibleQuestion && question.behaviorObject?.isRequired ? yup.string().required(() => fieldErrorMessage(question)) : yup.string().notRequired();
    }
    return yup.object().shape(validationSchema);
  }

  const handleCkeckConsuption = async (isIssue = false) => {
    try {
      const { data: consumptionData } = await useCheckConsumptionRequest({}, { isIssue });
      return !!consumptionData?.value?.availableLimit;
    } catch (err) {
      if (err?.response?.data?.errors?.length) {
        err?.response?.data?.errors.map(error => mc.error(error.message))
      } else {
        mc.error("Falha ao confirmar a sua cotação, tente novamente!")
      }
      return false;
    }
  }

  const handleGenerateQuote = async (values) => {
    const canConsumeLimite = await handleCkeckConsuption();
    if (!canConsumeLimite) return;

    buildValidation().validate(values, { abortEarly: false })
      .then(() => {
        handleSaveQuestionnaireAnswer(values, props.match?.params?.idOperation)
      })
      .catch((e) => {
        onValidationError(e, mc, formikRef, questionnaire, [])
      })
  }

  const handleSaveQuestionnaireAnswer = (values, idOperation, onlyQuestions) => {
    const formValues = JSON.parse(JSON.stringify(values));

    const body = { questionnaireAnswers: [] };
    for (const [key, section] of Object.entries(SECTIONS)) {
      if (section.isMultiple) {
        let multipleFields = []
        switch (section.name) {
          default:
            multipleFields = [];
            break;
        }

        multipleFields.map((field, index) => {
          let sectionAnswers = formValues[`$ANSWERS_${section.name}_${index}`];
          if (sectionAnswers?.length) {
            const rootQuestion = sectionAnswers.find(question => !question.idQuestionRoot);
            const childrenQuestions = sectionAnswers.filter(question => question.idQuestionRoot);
            rootQuestion.childrenQuestions = childrenQuestions
            if (!onlyQuestions) {
              body.questionnaireAnswers = [...body.questionnaireAnswers, rootQuestion];
            } else {
              body.questionnaireAnswers = [...body.questionnaireAnswers, ...sectionAnswers];
            }
          }
        })
      } else {
        let sectionAnswers = formValues[`$ANSWERS_${section.name}`];
        if (sectionAnswers) {
          body.questionnaireAnswers = [...body.questionnaireAnswers, ...sectionAnswers];
        }
      }
    }

    for (const question of body.questionnaireAnswers) {
      if ((question.idDomainQuestion === 270 || question.idDomainQuestion === 271) && question.answer) {
        try {
          question.answer = JSON.stringify(question.answer)
        } catch (e) {
        }
      }
    }

    if (onlyQuestions) return body.questionnaireAnswers;

    if (idOperation) {
      useSaveQuestionnaireAnswerRequest(body.questionnaireAnswers);
    }
  }

  useEffect(() => {
    updateIsLoadingStatus(
      useGetQuestionnairesAnswersLoading ||
      useSaveQuestionnaireAnswerLoading ||
      useGenerateQuoteLoading ||
      useGetDocumentsLoading ||
      useRequestSompoGetInternalProcessNumberLoading
    )
  }, [
    useGetQuestionnairesAnswersLoading,
    useSaveQuestionnaireAnswerLoading,
    useGenerateQuoteLoading,
    useGetDocumentsLoading,
    useRequestSompoGetInternalProcessNumberLoading
  ]);

  useEffect(() => {
    if (!useGetDocumentsStatus) return;
    if (useGetDocumentsStatus === 200) {
      const [quoteRequestDocument] = useGetDocumentsData.value;
      handleGetQuote(quoteRequestDocument.documentCoverageList);
    }
  }, [useGetDocumentsStatus])

  useEffect(() => {
    useGetQuestionnairesAnswersRequest(null, { idDomainStatus: null })
    useGetDocumentsRequest(null, { idDomain: 261 });
  }, []);

  useEffect(() => {
    if (useGetQuestionnairesAnswersStatus === 200) {
      handleQuestionnaire(useGetQuestionnairesAnswersData?.value)
    }
  }, [useGetQuestionnairesAnswersStatus]);

  useEffect(() => {
    if (useSaveQuestionnaireAnswerStatus === 200) {
      if (!goToNextPage.current) {
        mc.success('informações salvas com sucesso!');
        return history.push('/list');
      }

      const questionnaireUpdated = handleSaveQuestionnaireAnswer(formikRef?.current?.values, false, true);

      const finishedQuestion = questionnaireUpdated.find(q => q.idQuestion == 1427 || q.idQuestion == 1603);
      const finishedAnalisys = finishedQuestion?.idAnswerOption === 7220 || finishedQuestion?.idAnswerOption === 6872;

      useGetQuestionnairesAnswersRequest(null, { idDomainStatus: null });

      const hasInternalProcessNumberAnswer = questionnaire.find(qst => qst.idQuestion === 3476)?.answer;
      if (!hasInternalProcessNumberAnswer) {
        useRequestSompoGetInternalProcessNumberRequest({ idOperation: props?.match?.params?.idOperation })
          .then(async (response) => {
            if (response.status !== 200) {
              return mc.error('Ocorreu um erro na requisição do sistema externo');
            }
            useGenerateQuoteRequest({ idDomainStatus: finishedAnalisys ? 16 : 19, idProductPlanSelected: idProductPlan })
          }).catch((e) => {
            return mc.error('Ocorreu um erro na requisição do sistema externo');
          })
      } else {
        useGenerateQuoteRequest({ idDomainStatus: finishedAnalisys ? 16 : 19, idProductPlanSelected: idProductPlan })
      }
    }
  }, [useSaveQuestionnaireAnswerStatus]);

  useEffect(() => {
    if (useGenerateQuoteStatus === 200) {
      history.push(`/quote/document/${props?.match?.params?.idProduct}/${props?.match?.params?.idOperation}`);
    }
  }, [useGenerateQuoteStatus]);


  useEffect(() => {
    buildValidation();
  }, [questionnaire]);

  const parseNumber = (value) => {
    if (typeof (value) === 'string') {
      if (value.startsWith('%')) return Number(value.replaceAll('%', '').replaceAll(',', '.'))

      return Number(value.replaceAll('R$', '').replaceAll('.', '').replaceAll(',', '.'))
    }
    return value
  }

  const handleGetQuote = async (documentCoverageList, previousCalculation) => {
    let calculations = documentCoverageList.coverageCalcList[0].coverageCalc ? documentCoverageList.coverageCalcList[0].coverageCalc : documentCoverageList.coverageCalcList;

    calculations = calculations.map((calculation, index) => {
      calculation.productPlanName = documentCoverageList.coverageCalcList[0].coverageCalc ? documentCoverageList.coverageCalcList[0].idProductPlanName : documentCoverageList.idProductPlanName;
      calculation.idProductPlan = documentCoverageList.coverageCalcList[0].coverageCalc ? documentCoverageList.coverageCalcList[0].idProductPlan : documentCoverageList.idProductPlan;
      calculation.option = index;
      calculation.deductibleDescription = String(calculation.deductibleDescription || 0.0);
      calculation.coverageComissionRate = String(parseNumber(calculation.coverageComissionRate || 0.0) * 100)

      calculation.coverageItems = calculation.coverageItems.map((coverage) => {
        coverage.coveragePremium = String(coverage.coveragePremium || 0.0);
        coverage.coveragePremiumDiscountLess = String(coverage.coveragePremiumDiscountLess || 0.0);
        coverage.coveragePremiumTaxLess = String(coverage.coveragePremiumTaxLess || 0.0);
        coverage.coveragePremiumDiscountRate = String((coverage.coveragePremiumDiscountRate || 0.0) * 100);
        coverage.coverageDisabled = coverage.coverageDisabled;
        coverage.coverageRate = String(Number((coverage.coverageRate || 0.0) * 100).toFixed(2))
        coverage.coverageLimit = String(coverage.coverageLimit ? parseNumber(coverage.coverageLimit || 0.0) : parseNumber(calculation.coverageLimit));
        coverage.deductibleDescription = String(coverage.deductibleDescription ? coverage.deductibleDescription : "");
        coverage.coverageMaxLimClaim = String(coverage.coverageMaxLimClaim ? parseNumber(coverage.coverageMaxLimClaim || 0.0) : parseNumber(calculation.coverageMaxLimClaim));
        coverage.coverageMaxLimClaimRate = String(coverage.coverageMaxLimClaimRate ? parseNumber(coverage.coverageMaxLimClaimRate || 0.0) * 100 : (coverage.coverageMaxLimClaim / coverage.coverageLimit) * 100);
        return coverage;
      });
      return calculation;

    })

    setIdProductPlan(calculations[0].idProductPlan);
  }

  return (
    <Layout
      title={"Analise da Cotação"}
      subtitle={`${operation?.productName || ""}`}
      idOperation={props.match.params.idOperation}
    >
      <Row>
        <Col>
          <StepNavigation
            stage={2}
            idOperation={props.match?.params?.idOperation}
            idProduct={props.match?.params?.idProduct}
            permissions={permissions}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <BrokingSummary
            idOperation={props.match?.params?.idOperation}
            idProduct={props.match?.params?.idProduct}
            permissions={permissions}
          />
        </Col>
      </Row>

      <Content>
        <Formik
          validateOnChange={false}
          innerRef={formikRef}
          initialValues={initialValues}
          validationSchema={validationSchema.current}
          enableReinitialize={true}
          onSubmit={() => true}
        >
          {({ values, setFieldValue }) => {
            return (
              <Form>
                <FormContainer title="Informações da carta de cotação">
                  <FormSection
                    sectionName="QUOTE_LETTER"
                    questionnaire={questionnaire}
                    values={values}
                    setFieldValue={setFieldValue}
                    ignoreModality
                    idProduct={props.match.params.idProduct}
                  />
                </FormContainer>

                <ButtonContainer>
                  <Button forth style={{ width: 'auto' }} onClick={() => handleBack()}> &lt; VOLTAR </Button>
                    <ButtonContent>
                      <HasPermission permission={permissions.CANCEL_ENQUIRY}>
                        <LostCancelButton idQuestion={3458} idOperation={props.match?.params?.idOperation} redirectTo={"/list"} />
                      </HasPermission>
                      <HasPermission permission={permissions.NBI_REQUEST_APPROVE_REJECT}>
                        <Button
                          id="btnContinue"
                          type="submit"
                          onClick={() => {
                            goToNextPage.current = false;
                            handleSaveQuestionnaireAnswer(values, props.match?.params?.idOperation)
                          }}
                          style={{ marginLeft: 15 }}
                          custom={[Colors.WHITE, Colors.TERTIARY]}
                        >
                          SALVAR
                        </Button>

                        <Button
                          id="btnContinue"
                          type="submit"
                          onClick={() => {
                            validationSchema.current.validate(values)
                              .then(() => {
                                goToNextPage.current = true;
                                handleGenerateQuote(values)
                              })
                              .catch((e) => {
                                console.log('validation error', e)
                              })
                          }}
                          style={{ marginLeft: 15 }}
                          primary
                        >
                          GERAR COTAÇÃO
                        </Button>
                      </HasPermission>
                    </ButtonContent>

                </ButtonContainer>
              </Form>
            )
          }}
        </Formik>
        {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
      </Content>
    </Layout >
  )
}